import Entity from "entity";

export default class Operador extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/9gAarOKY66aXOYcWNuFM/Values";
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO")
    }

    async initialize() {
        this.data.status = "ATIVO"
    }

    static get labelField() {
        return "operador";
    }

    static get searchColumns() {
        return [
            { field: "sequencialIndex", headerName: "Código", flex: 0.8, filter: true },
            { field: "cliente.nome", headerName: "Cliente", flex: 1, filter: true },
            { field: "operador", headerName: "Operador", flex: 1, filter: true },
        ];
    }
}
